import { InventoryPage } from '@jupi/ui'

// The whole inventory on the maintenance site: the same list, search, filters
// and stock editing as the admin app, for whoever holds the inventory
// permissions.
export default function PartsPage() {
  return <InventoryPage />
}
